import { render, staticRenderFns } from "./FormToggle.vue?vue&type=template&id=2addc9c0&scoped=true&"
import script from "./FormToggle.vue?vue&type=script&lang=js&"
export * from "./FormToggle.vue?vue&type=script&lang=js&"
import style0 from "./FormToggle.vue?vue&type=style&index=0&id=2addc9c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2addc9c0",
  null
  
)

export default component.exports